import { Injectable } from '@angular/core';

@Injectable()
export class graphYear {
    public _graphYr : any [] = [   
        { value:'2017', name: '2017' },
        { value:'2018', name: '2018' },
        { value:'2019', name: '2019' },
        { value:'2020', name: '2020' },
        { value:'2021', name: '2021' },
        { value:'2022', name: '2022' },
        { value:'2023', name: '2023' },
        { value:'2024', name: '2024' }
      ];
    constructor() { }
}

@Injectable()
export class graphDataBy {
    public _graphData : any [] = [   
        { value:'total', name: 'Totales' },
        { value:'count', name: 'Cantidad' }
      ];
    constructor() { }
}

